//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { ImportAddProductsModel } from '../Models/ImportModels/ImportProductsModels/ImportAddProductsModel';
import { ImportUpdateProductsModel } from '../Models/ImportModels/ImportProductsModels/ImportUpdateProductsModel';
import { ImportStocksOptionsModel } from '../Models/ImportModels/ImportStocksModels/ImportStocksOptionsModel';

import { boundClass } from 'autobind-decorator';
import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import { encodeUrlParameter, getAxiosData } from '../../../common/urlUtility';
@boundClass export class ImportController
{
  
  private readonly axios: AxiosInstance
  
  constructor (axios: AxiosInstance)
  {
    this.axios = axios
  }
  importProductsOzon(ozonAccountId: number, model: ImportAddProductsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/ImportProductsOzon/${encodeUrlParameter(ozonAccountId)}`, model, _config).then(getAxiosData)
  }
  

  updateProductsOzon(ozonAccountId: number, model: ImportUpdateProductsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/UpdateProductsOzon/${encodeUrlParameter(ozonAccountId)}`, model, _config).then(getAxiosData)
  }
  

  importProductsWb(wbAccountId: number, model: ImportAddProductsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/ImportProductsWb/${encodeUrlParameter(wbAccountId)}`, model, _config).then(getAxiosData)
  }
  

  updateProductsWb(wbAccountId: number, model: ImportUpdateProductsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/UpdateProductsWb/${encodeUrlParameter(wbAccountId)}`, model, _config).then(getAxiosData)
  }
  

  importProductsYandexMarket(yandexMarketAccountId: number, model: ImportAddProductsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/ImportProductsYandexMarket/${encodeUrlParameter(yandexMarketAccountId)}`, model, _config).then(getAxiosData)
  }
  

  updateProductsYandexMarket(yandexMarketAccountId: number, options: ImportUpdateProductsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/UpdateProductsYandexMarket/${encodeUrlParameter(yandexMarketAccountId)}`, options, _config).then(getAxiosData)
  }
  

  importStocksOzon(ozonAccountId: number, options: ImportStocksOptionsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/ImportStocksOzon/${encodeUrlParameter(ozonAccountId)}`, options, _config).then(getAxiosData)
  }
  

  importStocksWb(wbAccountId: number, options: ImportStocksOptionsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/ImportStocksWb/${encodeUrlParameter(wbAccountId)}`, options, _config).then(getAxiosData)
  }
  

  importStocksYandexMarket(yandexMarketAccountId: number, options: ImportStocksOptionsModel, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`Import/ImportStocksYandexMarket/${encodeUrlParameter(yandexMarketAccountId)}`, options, _config).then(getAxiosData)
  }
  

}
